import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full" style={{
    background: '#3a3a3a'
  }} data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-171">
        {/* Main grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8" data-id="element-172">
          {/* Col 1: Brand */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-1" data-id="element-173">
            <div className="mb-4" data-id="element-174">
              <img src="https://cdn.magicpatterns.com/uploads/7USU4UNCfkQ3xhTRzMh17Q/ChatGPT_Image_Feb_27,_2026,_05_46_21_PM.png" alt="Ameritech Inc Tires & Wheels Center" className="h-16 w-auto object-contain" style={{
              background: 'white',
              borderRadius: '4px',
              padding: '4px 8px'
            }} data-id="element-175" />
            </div>
            <p className="text-gray-400 text-xs leading-relaxed mb-2" data-id="element-176">
              Quality. Safety. Performance.
            </p>
            <p className="text-xs leading-relaxed" style={{
            color: '#888'
          }} data-id="element-177">
              Serving the DMV area since 1995. Cottage City, Capitol Heights
              &amp; Suitland, MD.
            </p>
            <div className="mt-4 space-y-1.5" data-id="element-178">
              <a href="tel:3012549001" className="flex items-center gap-2 text-gray-400 text-xs hover:text-white transition-colors" data-id="element-179">
                <PhoneIcon size={12} data-id="element-180" />
                (301) 254-9001
              </a>
              <a href="mailto:info@ameritechtires.com" className="flex items-center gap-2 text-gray-400 text-xs hover:text-white transition-colors" data-id="element-181">
                <MailIcon size={12} data-id="element-182" />
                info@ameritechtires.com
              </a>
            </div>
          </div>

          {/* Col 2: Our Services */}
          <div data-id="element-183">
            <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-4" data-id="element-184">
              Our Services
            </h3>
            <ul className="space-y-2" data-id="element-185">
              <li data-id="element-186">
                <Link to="/services/tire-sales" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-187">
                  Tire Sales
                </Link>
              </li>
              <li data-id="element-188">
                <Link to="/services/tire-installation" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-189">
                  Tire Installation
                </Link>
              </li>
              <li data-id="element-190">
                <Link to="/services/tire-rotation" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-191">
                  Tire Rotation
                </Link>
              </li>
              <li data-id="element-192">
                <Link to="/services/flat-tire-repair" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-193">
                  Flat Tire Repair
                </Link>
              </li>
              <li data-id="element-194">
                <Link to="/services/free-tire-checks" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-195">
                  Free Tire Checks
                </Link>
              </li>
              <li data-id="element-196">
                <Link to="/services/emergency-roadside" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-197">
                  Emergency Roadside
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Locations */}
          <div data-id="element-198">
            <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-4" data-id="element-199">
              Locations
            </h3>
            <ul className="space-y-2" data-id="element-200">
              <li data-id="element-201">
                <Link to="/locations" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-202">
                  Cottage City
                </Link>
              </li>
              <li data-id="element-203">
                <Link to="/locations" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-204">
                  Capitol Heights
                </Link>
              </li>
              <li data-id="element-205">
                <Link to="/locations" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-206">
                  Suitland
                </Link>
              </li>
              <li data-id="element-207">
                <Link to="/locations" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-208">
                  Find a Location
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Resources */}
          <div data-id="element-209">
            <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-4" data-id="element-210">
              Resources
            </h3>
            <ul className="space-y-2" data-id="element-211">
              <li data-id="element-212">
                <Link to="/about" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-213">
                  About Us
                </Link>
              </li>
              <li data-id="element-214">
                <Link to="/reviews" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-215">
                  Reviews
                </Link>
              </li>
              <li data-id="element-216">
                <Link to="/services" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-217">
                  Tire Tips Blog
                </Link>
              </li>
              <li data-id="element-218">
                <Link to="/contact" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-219">
                  FAQs
                </Link>
              </li>
              <li data-id="element-220">
                <Link to="/contact" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-221">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 5: Work With Us */}
          <div data-id="element-222">
            <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-4" data-id="element-223">
              Work With Us
            </h3>
            <ul className="space-y-2" data-id="element-224">
              <li data-id="element-225">
                <Link to="/become-partner" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-226">
                  Become a Partner
                </Link>
              </li>
              <li data-id="element-227">
                <Link to="/fleet-services" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-228">
                  Fleet Services
                </Link>
              </li>
              <li data-id="element-229">
                <Link to="/request-info" className="text-gray-400 text-sm hover:text-white transition-colors" data-id="element-230">
                  Request Info
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 6: Follow Us + Trust Badge */}
          <div data-id="element-231">
            <h3 className="text-white font-bold text-sm uppercase tracking-wide mb-4" data-id="element-232">
              Follow Us
            </h3>
            <div className="flex gap-2 mb-6" data-id="element-233">
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors" style={{
              background: 'rgba(255,255,255,0.10)'
            }} onMouseEnter={e => e.currentTarget.style.background = '#CC0000'} onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'} data-id="element-234">
                <FacebookIcon size={16} className="text-white" data-id="element-235" />
              </a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors" style={{
              background: 'rgba(255,255,255,0.10)'
            }} onMouseEnter={e => e.currentTarget.style.background = '#CC0000'} onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'} data-id="element-236">
                <InstagramIcon size={16} className="text-white" data-id="element-237" />
              </a>
              <a href="#" aria-label="Twitter" className="w-9 h-9 rounded-full flex items-center justify-center transition-colors" style={{
              background: 'rgba(255,255,255,0.10)'
            }} onMouseEnter={e => e.currentTarget.style.background = '#CC0000'} onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.10)'} data-id="element-238">
                <TwitterIcon size={16} className="text-white" data-id="element-239" />
              </a>
            </div>

            {/* Trust badge */}
            <div className="w-24 h-24 rounded-full flex flex-col items-center justify-center text-center" style={{
            border: '2px solid rgba(255,255,255,0.20)'
          }} data-id="element-240">
              <span className="font-black text-2xl leading-none" style={{
              color: '#FECB00'
            }} data-id="element-241">
                #1
              </span>
              <span className="text-white text-xs font-bold leading-tight mt-0.5" data-id="element-242">
                MOST
                <br data-id="element-243" />
                TRUSTED
              </span>
              <span className="text-xs mt-0.5" style={{
              color: '#888'
            }} data-id="element-244">
                DMV Area
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10" data-id="element-245">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-246">
          <p className="text-xs" style={{
          color: '#888'
        }} data-id="element-247">
            © 2026 Ameritech Tires. All Rights Reserved.
          </p>
          <div className="flex gap-5" data-id="element-248">
            <a href="#" className="text-xs transition-colors" style={{
            color: '#888'
          }} onMouseEnter={e => e.currentTarget.style.color = '#ffffff'} onMouseLeave={e => e.currentTarget.style.color = '#888'} data-id="element-249">
              Privacy Policy
            </a>
            <a href="#" className="text-xs transition-colors" style={{
            color: '#888'
          }} onMouseEnter={e => e.currentTarget.style.color = '#ffffff'} onMouseLeave={e => e.currentTarget.style.color = '#888'} data-id="element-250">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}